import { serializeQuery } from './api.utils'
import { BaseApi } from './base.api'

export class DictWordTypeApi extends BaseApi {
	constructor() {
		super('api/editor/dict-word-type')
	}

	// async getAll() {
	// 	const rs = await this.get('')
	// 	return rs
	// }
	async getAllWordTypes(data) {
		const query = serializeQuery(data)
		const rs = await this.get(`?${query}`)
		return rs
	}

	async create(data) {
		const rs = await this.post('', data)
		return rs
	}

	async update(data) {
		const rs = await this.put(`/${data.id}`, data)
		return rs
	}

	async remove(data) {
		const rs = await this.delete(`/${data.id}`)
		return rs
	}
}
